export function buildGoogleCalendarLink(
  start: string,
  end: string,
  userFullname: string,
): void {
  const formattedStartAt = `${new Date(start)
    .toISOString()
    .slice(0, 19)
    .replace(/-/g, '')
    .replace(/:/g, '')}Z`;
  const formattedEndAt = `${new Date(end)
    .toISOString()
    .slice(0, 19)
    .replace(/-/g, '')
    .replace(/:/g, '')}Z`;

  window.open(
    `https://calendar.google.com/calendar/render?action=TEMPLATE&text=Sess%C3%A3o%20-%20${encodeURI(
      userFullname,
    )}&dates=${formattedStartAt}/${formattedEndAt}`,
    '_blank',
  );
}
